module.exports = __webpack_public_path__ + "static/media/icon-sun.0d67c1ef.svg";